var EntitySearch = function EntitySearch(form, settings) {
  this.form = form;
  this.settings = $.extend({
    searchInterval: 500,
    minSearchLength: 2,
    quickSearchClass: 'quick-search',
    loaderClass: 'loader',
    callback: null
  }, settings);

  var _this = this;

  var $form = this.form;
  var ajaxReq = null;
  var href = '';
  this.form.find('.row:not(:nth-child(2))').hide();
  this.form.find('a.more').attr('href', '');
  this.form.find('a.more').on('click', function (e) {
    $(this).find('span').html($(this).find('span').html().match(/more/) ? '&uarr; less' : '&darr; more');
    $form.find('.row:not(:nth-child(2))').toggle();
    e.preventDefault();
    return false;
  }); // Form submit

  this.form.on('submit', function () {
    if (_this.triggeredFromQuicksearch !== true) {
      $form.find('.' + _this.settings.loaderClass).show();
    }

    _this.triggeredFromQuicksearch = false;

    if (ajaxReq) {
      ajaxReq.abort();
    }

    ajaxReq = $.ajax({
      url: this.action,
      data: $(this).serialize(),
      dataType: 'html'
    }).done(function (data) {
      // Remove loading indicators
      $form.find('.' + _this.settings.loaderClass).hide();
      $form.find('.' + _this.settings.quickSearchClass).removeClass('loading');
      var html = $($.parseHTML(data)).find('.list-container').html();
      $('.list-container').html(html);

      if (typeof _this.settings.callback === 'function') {
        _this.settings.callback();
      }

      href = window.location.origin + window.location.pathname + '?' + $form.serialize();

      if (window.location.search) {
        window.history.replaceState(null, null, href);
      } else {
        window.history.pushState(null, null, href);
      }
    }).always(function () {
      ajaxReq = null;
    }); // TODO: use pushState / popState

    return false;
  });
  $(window).on('popstate', function () {
    ajaxReq = $.ajax({
      url: window.location.href,
      data: window.location.search
    }).done(function (data) {
      $('.list-container').html($(data).find('.list-container').html());

      if (typeof _this.settings.callback === 'function') {
        _this.settings.callback();
      }
    }).always(function () {
      ajaxReq = null;
    });

    if (!window.location.search) {
      $form.trigger('reset');
    }
  }); // Form reset

  this.form.find('input[type=reset], button[type=reset]').on('click', function () {
    this.form.reset();
    $('#' + this.form.id).find('.for_chosen').trigger('chosen:updated');
  }); // Submit if query fields change

  this.form.find('input[type=radio]').on('change', function () {
    var q = $form.find('.' + _this.settings.quickSearchClass).val().trim();

    if (q !== '') {
      $form.find('.' + _this.settings.quickSearchClass).addClass('loading');
      $form.trigger('submit');
    }
  });
  this.form.attr('autocomplete', 'off'); // Bind quickSearchClass focus/blur

  this.form.find('.' + this.settings.quickSearchClass).each(function () {
    var ESC_KEY = 'Escape';
    var ENTER_KEY = 'Enter';
    var UP_KEY = 'ArrowUp';
    var DOWN_KEY = 'ArrowDown'; // Add key Handler

    $(this).on('keyup keydown', function (e) {
      switch (e.key) {
        // Esc
        case ESC_KEY:
          this.blur();
          return false;
        // Enter

        case ENTER_KEY:
          e.preventDefault();
          return false;
        // Up

        case UP_KEY:
          e.preventDefault();
          return false;
        // Down

        case DOWN_KEY:
          e.preventDefault();
          return false;

        default:
          var value = $(this).val().trim();
          var hasMinValue = value.length >= _this.settings.minSearchLength;
          var hasValue = hasMinValue || value.length === 0;
          var isNotLastSearch = $(this).attr('data-last-search') !== value;
          var tid = null;

          if ($(this).hasClass('focused') && hasValue && isNotLastSearch) {
            clearTimeout($(this).attr('data-timeout-id'));
            tid = setTimeout($.proxy(function () {
              // Store last search
              $(this).attr('data-last-search', $(this).val().trim()); // Loading

              $(this).addClass('loading'); // Submit

              _this.triggeredFromQuicksearch = true;
              $form.trigger('submit');
            }, this), _this.settings.searchInterval); // Store timeout id

            $(this).attr('data-timeout-id', tid);
          }

          return true;
      }
    }); // Focus

    $(this).on('focus', function () {
      $(this).addClass('focused');
    }); // Blur

    $(this).on('blur', function () {
      clearTimeout($(this).attr('data-timeout-id'));
      $(this).removeClass('focused');
    });
  });
};

$.fn.entitysearch = function (settings) {
  // Apply to all instances
  this.each(function () {
    this.entity = new EntitySearch($(this), settings || {});
  });
};